import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

import installationMonorepoApi from '~/services/installation-monorepo/installation-monorepo';

export const installationBypassQueryKey = (partnerId: number) => [
  'partner-installation-bypass',
  partnerId,
] as const;

export default function useInstallationBypass(partnerId: Ref<number>) {
  return useQuery({
    enabled: computed(() => !!partnerId.value && partnerId.value > 0),
    queryFn: () => installationMonorepoApi.getByPartnerId({ partnerId: partnerId.value }),
    queryKey: computed(() => installationBypassQueryKey(partnerId.value)),
    retry: 3,
  });
}
